import { render, staticRenderFns } from "./affixService.vue?vue&type=template&id=f07b712a&scoped=true"
import script from "./affixService.vue?vue&type=script&lang=js"
export * from "./affixService.vue?vue&type=script&lang=js"
import style0 from "./affixService.vue?vue&type=style&index=0&id=f07b712a&prod&lang=scss&scoped=true"
import style1 from "./affixService.vue?vue&type=style&index=1&id=f07b712a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07b712a",
  null
  
)

export default component.exports